import i18n from "@/modules/i18n"

export default {
  methods: {
    periodCount(days, key = "default") {
      if (days >= 365 && days % 365 === 0) {
        return i18n.tc(`period-count.years.${key}`, days / 365)
      }
      if (days >= 31 && days % 31 === 0) {
        return i18n.tc(`period-count.months.${key}`, days / 31)
      }
      return i18n.tc(`period-count.days.${key}`, days)
    }
  }
}
